import apiClient from "./index";

/**
 * Fetch a list of venues with pagination.
 * @param {number} limit - The maximum number of venues to fetch.
 * @param {string} lastEvaluatedKey - The last evaluated key for pagination.
 * @returns {Promise<object>} - The response data containing venues and pagination details.
 */
export const getVenues = async (limit = 10, lastEvaluatedKey = null) => {
  try {
    const { data } = await apiClient.get("/venues", {
      params: {
        limit,
        lastEvaluatedKey,
      },
    });
    return data;
  } catch (error) {
    console.error("Failed to fetch venues:", error);
    throw new Error(error.response?.data?.message || "Error fetching venues");
  }
};

/**
 * Create a new venue.
 * @param {object} venue - The venue data to be created.
 * @returns {Promise<object>} - The response data of the created venue.
 */
export const createVenue = async (venue) => {
  try {
    const { data } = await apiClient.post("/venues", venue);
    return data;
  } catch (error) {
    console.error("Failed to create venue:", error);
    throw new Error(error.response?.data?.message || "Error creating venue");
  }
};

/**
 * Update an existing venue.
 * @param {string} venueId - The ID of the venue to update.
 * @param {object} venue - The updated venue data.
 * @returns {Promise<object>} - The response data of the updated venue.
 */
export const updateVenue = async (venueId, venue) => {
  try {
    const { data } = await apiClient.put(`/venues/${venueId}`, venue);
    return data;
  } catch (error) {
    console.error("Failed to update venue:", error);
    throw new Error(error.response?.data?.message || "Error updating venue");
  }
};

/**
 * Delete a venue by its ID.
 * @param {string} venueId - The ID of the venue to delete.
 * @returns {Promise<object>} - The response data confirming deletion.
 */
export const deleteVenue = async (venueId) => {
  try {
    const { data } = await apiClient.delete(`/venues/${venueId}`);
    return data;
  } catch (error) {
    console.error("Failed to delete venue:", error);
    throw new Error(error.response?.data?.message || "Error deleting venue");
  }
};
